export const API_BASE =
  (import.meta.env.VITE_API_URL as string | undefined) ?? "https://onchainreps-api.vercel.app";

export interface ApiOptions {
  token?: string | null;
  method?: "GET" | "POST" | "DELETE";
  body?: unknown;
}

export interface ApiResult<T> {
  data: T | null;
  error: string | null;
}

export async function apiRequest<T>(path: string, options: ApiOptions = {}): Promise<ApiResult<T>> {
  const headers: Record<string, string> = { Accept: "application/json" };
  if (options.body !== undefined) headers["Content-Type"] = "application/json";
  if (options.token) headers.Authorization = `Bearer ${options.token}`;

  try {
    const response = await fetch(`${API_BASE}${path}`, {
      method: options.method ?? "GET",
      headers,
      body: options.body === undefined ? undefined : JSON.stringify(options.body),
    });
    const text = await response.text();
    const payload = text ? (JSON.parse(text) as Record<string, unknown>) : {};
    if (!response.ok) {
      const message = typeof payload.error === "string" ? payload.error : `Request failed (${response.status})`;
      return { data: null, error: message };
    }
    return { data: payload as T, error: null };
  } catch (cause) {
    return { data: null, error: cause instanceof Error ? cause.message : "The API could not be reached." };
  }
}

export interface LinkedAccount {
  id: string;
  provider: string;
  provider_user_id: string;
  username: string | null;
  last_synced_at: string | null;
  created_at: string;
}

export interface SyncedGame {
  id: string;
  source: string;
  pgn: string;
  result: string | null;
  white: string | null;
  black: string | null;
  opening: string | null;
  eco: string | null;
  played_at: string | null;
  accuracy_white: number | null;
  accuracy_black: number | null;
  player_color: "white" | "black" | null;
}
